import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const requireTableContextGuard: CanActivateFn = (route) => {
  const storeId = route.paramMap.get('storeId');
  const tableId = route.queryParamMap.get('tableid');

  if (storeId && tableId) {
    return true;
  }

  return inject(Router).createUrlTree(['/demo']);
};
